import { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { useRouter } from 'next/router';
import AppBarTitle from '../../@components/AppBarTitle';
import UserIconMenu from './@components/UserIconMenu';
import LogoutModal from './@components/LogoutModal';
import DrawerMenuList from './@components/DrawerMenuList';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    height: '100%',
    // '& [class^=PrivateHiddenCss-xsDown]': {
    //   height: '100%',
    // },
    // '& .MuiDrawer-root': {
    //   height: '100%',
    // },
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerClose: {
    width: 'unset',
  },
  hiddenXsDown: {
    height: '100%',
  },
  drawerDesktopRoot: {
    height: '100%',
  },
  // appBar: {
  //   [theme.breakpoints.up('sm')]: {
  //     width: `calc(100% - ${drawerWidth}px)`,
  //     marginLeft: drawerWidth,
  //   },
  // },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  desktopMenuButton: {
    color: '#fff',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaperMobile: {
    width: drawerWidth,
  },
  drawerPaper: {
    height: '100%',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  content: {
    flexGrow: 1,
    // padding: theme.spacing(3),
    width: `calc(100% - ${drawerWidth}px)`,
    '& main': {
      margin: theme.spacing(2),
    },
    background: '#f2f2f2',
    '& .MuiInputBase-input': {
      background: '#ffffff',
    },
  },
  title: {
    flexGrow: 1,
  },
  logoDesktopMenuClose: {
    display: 'inline',
    verticalAlign: 'middle',
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarShift: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
  avatarSmall: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  boxContainer: {
    width: '100%',
    minHeight: '100vh',
    '& .ContentContainer': {
      height: '100%',
    },
  },
}));

function Page(props) {
  const { children } = props;
  const classes = useStyles();
  const theme = useTheme();
  const router = useRouter();
  const [desktopOpen, setDesktopOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDesktopDrawerToggle = () => {
    setDesktopOpen(!desktopOpen);
  };
  const handleMenuClick = (link) => {
    setMobileOpen(false);
    router.push(link);
  };

  const container = typeof window !== 'undefined' ? () => window.document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* <AppBar position="fixed" className={classes.appBar}> */}
      <AppBar position="absolute" className={clsx(classes.appBar, desktopOpen && classes.appBarShift)}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>

          <IconButton
            edge="start"
            onClick={handleDesktopDrawerToggle}
            className={classes.desktopMenuButton}
          >
            {desktopOpen ? <MenuOpenIcon /> : <MenuIcon />}
          </IconButton>
          {/* {
            !desktopOpen && (
              <div className={clsx(classes.logo, classes.logoDesktopMenuClose)}>
                <img src="/logo.png" alt="logo" />
              </div>
            )
          } */}

          <AppBarTitle />

          <UserIconMenu />

        </Toolbar>
      </AppBar>

      <div className={classes.boxContainer}>
        <Box className="ContentContainer" display="flex" bgcolor="background.paper">
          <Box>
            {/* <nav className={classes.drawer} aria-label="mailbox folders"> */}
            <nav className={clsx(classes.drawer, !desktopOpen && classes.drawerClose)} aria-label="mailbox folders">
              {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
              <Hidden smUp implementation="css">
                <Drawer
                  container={container}
                  variant="temporary"
                  anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                  open={mobileOpen}
                  onClose={handleDrawerToggle}
                  classes={{
                    paper: classes.drawerPaperMobile,
                  }}
                  ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                  }}
                >
                  <DrawerMenuList
                    onMenuClick={handleMenuClick}
                    desktopOpen={desktopOpen}
                  />
                </Drawer>
              </Hidden>
              <Hidden xsDown implementation="css" className={classes.hiddenXsDown}>
                <Drawer
                  className={classes.drawerDesktopRoot}
                  classes={{
                    paper: clsx(
                      classes.drawerPaper,
                      !desktopOpen && classes.drawerPaperClose,
                    ),
                  }}
                  variant="permanent"
                  open={desktopOpen}
                >
                  <DrawerMenuList
                    onMenuClick={handleMenuClick}
                    desktopOpen={desktopOpen}
                  />
                </Drawer>
              </Hidden>
            </nav>
          </Box>
          <Box className={classes.content}>
            <main>
              <div className={classes.toolbar} />
              {children}
            </main>
          </Box>
        </Box>
      </div>

      <LogoutModal />
    </div>
  );
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Page;
